import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import AntdTextField from '../../common/antd-form-components/AntdTextField';
import AntdSelectOption from '../../common/antd-form-components/AntdSelectOption';
import { DeleteOutlined } from '@ant-design/icons';
import { useFieldArray } from 'react-hook-form';
import RenderVariant from './RenderVariant';
import { useTranslation } from 'react-i18next';

const VariantsComponentV1 = (props) => {
  const { t } = useTranslation();
  let control = props?.control;
  const {
    fields: variantsFields1,
    append: appendVariantsField1,
    remove: removeVariantsField1
  } = useFieldArray({
    control,
    name: `variants1`
  });

  return (
    <div className="fields-array-ul-content">
      <ul className="fields-array-ul with-border">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <h2>{t('Inventory.Products.multiplicityDetails')}</h2>
          <div
            className="add-new-field-btn"
            onClick={() => {
              appendVariantsField1({
                id: '',
                value: ''
              });
            }}
          >
            <span>{t('Inventory.Products.addNewMultiType')}</span>
          </div>
        </div>
        <>
          {variantsFields1?.length > 0 &&
            variantsFields1?.map((item, index) => {
              return (
                // <li key={item?.id}>
                //     <RenderVariant item={item} index={index} control={control} setValue={props.setValue} watch={props.watch} errors={props.errors} allVariants={props.allVariants} variantsFields={variantsFields} removeVariantsField={removeVariantsField}/>
                // </li>
                <li key={index}>
                  <div className="field-delete-li">
                    <div className="select-label-wrap">
                      <p className="label-p">
                        {t('Inventory.Products.multiplicityType')}
                      </p>
                      <div className="custom-select-wrap without-icon">
                        <AntdSelectOption
                          name={`variants1.${index}.id`}
                          // name={`multiProducts.${index}.variants.${index}.id`}
                          errorMsg={
                            props.errors?.variant?.id &&
                            props.errors.multiProducts[props.index]?.variant
                              .id &&
                            props.errors.multiProducts[props.index].variant.id
                              .message
                          }
                          validateStatus={
                            props.errors?.variant?.id &&
                            props.errors.multiProducts[props.index].variant.id
                              ? 'error'
                              : ''
                          }
                          control={control}
                          setValue={props.setValue}
                          placeholder={t('Inventory.Products.multiplicityType')}
                          options={
                            props.allVariants?.length > 0
                              ? props.allVariants.map((obj) => ({
                                  title: obj.name,
                                  value: String(obj.id)
                                }))
                              : null
                          }
                          formClassName="store-new-product-form"
                        />
                      </div>
                    </div>
                    <div className="text-field-label-wrap">
                      <p className="label-p">
                        {t('Inventory.Products.valueTypeMultiplicity')}
                      </p>
                      <div className="text-field-wrap">
                        <AntdTextField
                          className="form-text-field"
                          name={`variants1.${index}.value`}
                          // name={`multiProducts.${index}.variants.${index}.value`}
                          type="text"
                          placeholder={t(
                            'Inventory.Products.valueTypeMultiplicityPlaceholder'
                          )}
                          errorMsg={
                            props.errors?.variant?.value &&
                            props.errors.multiProducts[props.index]?.variant
                              .value &&
                            props.errors.multiProducts[props.index].variant
                              .value.message
                          }
                          validateStatus={
                            props.errors?.variant?.value &&
                            props.errors.multiProducts[props.index]?.variant
                              .value &&
                            props.errors.multiProducts[props.index].variant
                              .value
                              ? 'error'
                              : ''
                          }
                          control={control}
                        />
                      </div>
                    </div>

                    {variantsFields1.length > 1 && (
                      <Tooltip title={t('Inventory.Products.delete')}>
                        <Button
                          className="delete-field-btn"
                          size="large"
                          type="dashed"
                          shape="circle"
                          icon={<DeleteOutlined />}
                          onClick={() => removeVariantsField1(index)}
                        />
                      </Tooltip>
                    )}
                  </div>
                </li>
              );
            })}
        </>
      </ul>
    </div>
  );
};

export default VariantsComponentV1;
